/**
 * Admin 사이드 테스트 패널 미리보기 여부. 호스트(chat-render)가 위젯 URL 에 `admin_preview=1` 을 붙인다.
 * 미리보기에서는 스크롤·펼치기·복사 등 화면 안 동작만 허용한다.
 * - 업무 액션(postMessage)은 호스트 handleWidgetMessage 가 선별해 버린다.
 * - 서버로 직접 쏘는 KPI 기록은 호출부가 isAdminPreview() 로 생략한다.
 * - postMessage 를 거치지 않는 일반 링크·폼 이동은 installAdminPreviewGuard 가 막는다.
 */
export function isAdminPreview(): boolean {
  try {
    return new URLSearchParams(window.location.search).get("admin_preview") === "1";
  } catch {
    return false;
  }
}

type ClosestTarget = { closest?: (selector: string) => { getAttribute(name: string): string | null } | null };

/** 브라우저 기본 이동을 일으키는 링크인가. 같은 문서 앵커(#…)·javascript: 는 이동이 아니다. */
export function isNavigatingLink(target: unknown): boolean {
  const anchor = (target as ClosestTarget | null)?.closest?.("a[href]");
  if (!anchor) return false;
  const href = (anchor.getAttribute("href") || "").trim();
  return href !== "" && !href.startsWith("#") && !/^javascript:/i.test(href);
}

/**
 * 미리보기에서 링크 클릭(가운데 클릭 포함)·폼 제출의 브라우저 기본 이동만 취소한다.
 * preventDefault 만 하므로 React onClick·onSubmit(복사·펼치기·우편번호 확인 등)은 그대로 실행된다.
 */
export function installAdminPreviewGuard(doc: Document = document): boolean {
  if (!isAdminPreview()) return false;
  const blockLink = (event: Event) => {
    if (isNavigatingLink(event.target)) event.preventDefault();
  };
  doc.addEventListener("click", blockLink, true);
  doc.addEventListener("auxclick", blockLink, true);
  doc.addEventListener("submit", (event) => event.preventDefault(), true);
  return true;
}
